/** Focus the module page CrudGrid / ConfigurableGrid keyboard container. */
export function focusModuleGridContainer(): void {
  document.querySelector<HTMLElement>('[data-ds-grid] [role="grid"]')?.focus({ preventScroll: true })
}
